module.exports = __webpack_public_path__ + "static/media/product-onoiwa-plus-detail.f3ad6ebd.png";